import React from 'react';
import { compose } from '../../../../src/web/utils/react';
import { widget } from '../../../../src/web/components/widgets/decorators';
import SiteStylesHelpLink from '../../../../src/web/components/SiteStylesHelpLink/SiteStylesHelpLink';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID, CONTEXT_MENU_MESSAGE, CONTEXT_MENU_LINK_TEXT } from './properties';
import HeaderLogo from './HeaderLogo';

const component = compose(
  widget(
    { name: NAME, category: 'Images', componentId: ID },
    {
      menu: {
        items: [
          {
            label: (
              <SiteStylesHelpLink
                message={CONTEXT_MENU_MESSAGE}
                linkText={CONTEXT_MENU_LINK_TEXT}
              />
            ),
          },
          'delete',
        ],
      },
    },
  ),
)(HeaderLogo);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
